
import React from 'react';
import { Repair } from '@/contexts/CarContext';
import { BadgeInfo } from 'lucide-react';
import { format, parseISO } from 'date-fns';

interface MechanicTagProps {
  repair?: Repair;
  notes?: string;
}

const MechanicTag: React.FC<MechanicTagProps> = ({ repair, notes }) => {
  if (repair && repair.addedByMechanic && repair.mechanicAddedDate) {
    const addedDate = parseISO(repair.mechanicAddedDate);
    return (
      <div className="flex items-center gap-1 text-xs text-gray-500 mt-1 italic">
        <BadgeInfo size={12} />
        <span>
          Added by {repair.mechanicName}
          {repair.garageName ? ` from ${repair.garageName}` : ''}
          {' via mechanic link on '}
          {format(addedDate, 'MMM d, yyyy')}
        </span>
      </div>
    );
  }
  
  if (notes && notes.includes('Added by') && notes.includes('via mechanic link')) {
    return (
      <div className="flex items-center gap-1 text-xs text-gray-500 mt-1 italic">
        <BadgeInfo size={12} />
        <span>{notes}</span>
      </div>
    );
  }
  
  return null;
};

export default MechanicTag;
